module.exports = __webpack_public_path__ + "img/sub_support_8.2c8a7364.png";